import { useEffect, useState } from 'react'

/**
 * Bir elemanın CANLI genişliği (px) — ResizeObserver ile.
 *
 * Sohbette hover aksiyon çubuğu buna göre düğme sayısını ayarlar: yan panel
 * sürüklenerek daraltılıp genişletilebildiği için sabit bir "dar/geniş" bayrağı
 * yetmiyordu (2026-08-27). Ölçüm SATIR BAŞINA değil, listenin kapsayıcısında bir
 * kez yapılır — elli mesaj için elli gözlemci açmanın anlamı yok.
 *
 * Gözlemci yoksa (çok eski tarayıcı) 0 döner; çağıran taraf bunu "bilinmiyor"
 * sayıp en geniş varsayıma düşmelidir — düğmeleri gizlemek, gereksiz gizlemekten
 * daha zararlıdır.
 */
export function useElementWidth(ref) {
  const [width, setWidth] = useState(0)
  useEffect(() => {
    const el = ref?.current
    if (!el || typeof ResizeObserver === 'undefined') return undefined
    setWidth(el.getBoundingClientRect().width)
    const ro = new ResizeObserver((entries) => {
      const w = entries[0]?.contentRect?.width
      if (w) setWidth(w)
    })
    ro.observe(el)
    return () => ro.disconnect()
  }, [ref])
  return width
}
